<template>
  <div>

    <table-widget :items="notes" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">
        <b-button b-btn v-b-modal.notes-modal v-if="isContractManager" class="new-note-button"><font-awesome-icon
            icon="plus" /> Add Note</b-button>
      </template>
      <template slot="content">
        <b-table striped hover :items="notes" :fields="fields" :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFiltered" responsive small>
          <template slot="createdDate" slot-scope="data">
            {{ data.item.createdDate | formatDate }}
          </template>
        </b-table>
      </template>
    </table-widget>

    <b-modal @shown="focusNote" id="notes-modal" title="Add note" v-model="show">
      <!-- element to gain focus when modal is opened -->
      <b-form-textarea ref="focusThis" v-model="noteText" placeholder="Enter notes" :rows="3" :max-rows="6">
      </b-form-textarea>
      <div slot="modal-footer">
        <b-btn variant="secondary" @click="show = false">Cancel</b-btn>
        <b-btn variant="primary" class="ml-2" @click="saveNote(); show = false">Save</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import contractApi from "../../api/contracts"
import { mapState } from "vuex"
import roleChecks from "../../misc/role-checks"
import TableWidget from "../table-widget"

export default {
  mixins: [roleChecks],
  data() {
    return {
      fields: [
        { key: "createdDate", sortable: true },
        { key: "createdBy", sortable: true },
        { key: "notes", sortable: true }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null,
      noteText: "",
      show: false
    }
  },

  components: {
    "table-widget": TableWidget
  },

  props: {
    notes: {
      type: Array,
      required: true
    },
    contractId: {
      required: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    focusNote: function (e) {
      console.log(e)
      this.$refs.focusThis.focus()
    },

    saveNote: function () {
      var that = this
      contractApi
        .postContractNote(this.contractId, this.noteText)
        .then(function (response) {
          that.notes.push(response.data)
          that.noteText = ""
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-note-button {
  margin-left: 10px;
}
</style>
